
import Vue from 'vue';
import { FormError } from '@/types/global';
import { ValidateTextfield } from '@/plugins/validators';
import { getTranslationString } from '~/utility/i18n';

export default Vue.extend({
  props: {
    id: { type: String, required: true },
    label: { type: String, required: true },
    placeholder: { type: String, required: true },
    maxLength: { type: String },
    initialErrors: {
      type: Array,
      default: () => [],
    },
    errorMessages: { type: Array, default: () => [] },
  },
  data() {
    return {
      optional: process.env.STORYBOOK_ENABLED ? 'optional' : getTranslationString(this.$globals, 'optional'),
      element: {} as HTMLFormElement,
      errors: [] as Array<string>,
      count: 0,
    };
  },
  mounted() {
    if (!process.env.STORYBOOK_ENABLED) {
      this.element = this.$el.querySelector('#' + this.id) as HTMLFormElement;
      window.addEventListener('validateField', (e: Event) => {
        const eventTarget = (e as CustomEvent).detail.element;
        if (eventTarget === this.element) {
          this.validate();
        }
      });
      window.addEventListener('validateForm', (e: Event) => {
        this.validate();
      });
      if (!this.isRequired) {
        this.$el.setAttribute('data-valid', 'true');
      }
    }

    // check for storybook initial errors
    if (this.initialErrors.length) {
      this.errors = (this.initialErrors as Array<string>).map(item => item);
    }
  },
  methods: {
    keyUpHandler() {
      if (!process.env.STORYBOOK_ENABLED) {
        this.count = this.element.value.length;
      }
    },
    validate() {
      this.errors = ValidateTextfield(this.element, this.errorMessages as Array<FormError>);

      if (this.errors.length === 0) {
        this.$el.setAttribute('data-valid', 'true');
      } else {
        this.$el.removeAttribute('data-valid');
      }
    },
  },
  computed: {
    isRequired(): Boolean {
      const messages = this.errorMessages as Array<FormError>;
      const requiredError = messages.filter((error: FormError) => error.type === 'required');
      return requiredError.length !== 0;
    },
  },
});
